import React, { useEffect, useRef, useState } from "react";
import {
  getDispatch,
  getSnackbarSuccess,
  MandatoryStar,
} from "../../../Utils/helper";
import { useDispatch, useSelector } from "react-redux";
import {
  EverGreenPOSTApi,
  GetInsurerSysChargeOrAdvAmount,
  deleteAdvancePaymentFiles,
} from "../../../redux/actions/PayoutAction";
import { GET_INSURER_TEST_PACKAGE_DETAIL } from "../../../Utils/types";

const AdvancePaymentPayout = ({
  paymentDetails,
  setPaymentDetails,
  setScreen,
  handleSearch,
}) => {
  const [insurerFile, setInsurerFile] = useState(null);
  const dispatch = useDispatch();
  const [packageArr, setPackageArr] = useState([]);

  const [checkedPt, setCheckedPt] = useState([]);
  const [testOrPackage, setTestOrPackage] = useState(null);
  const [addTest, setAddTest] = useState([]);
  const [list, setList] = useState([]);
  const [advInsAmount, setAdvInsAmount] = useState(null);
  const payoutReducer = useSelector((state) => state?.PayoutReducer);
  const backRef = useRef();
  const [deletedFiles, setdeletedFiles] = useState(null);

  const [dcFiles, setdcFiles] = useState(null);
  const [networkFiles, setnetworkFiles] = useState(null);
  const [financeFiles, setfinanceFiles] = useState(null);
  const [userRoleCode, setUserRoleCode] = useState(null);

  const onChangeHandler = (name, value) => {
    setPaymentDetails({
      ...paymentDetails,
      [name]: value,
    });
  };
  const [insurerAttachments, setInsurerAttachments] = useState(null);
  const [qRCodeAttachments, setQRCodeAttachments] = useState(null);

  const addTestPriceHandler = (id, name, value) => {
    const arr = addTest?.map((ele, index) => {
      if (id === index) {
        ele[name] = value;
      }
      return ele;
    });
    setAddTest(arr);
  };

  const insurerPriceHandler = (id, name, value) => {
    let arr = list?.map((ele, index) => {
      if (id === index) {
        ele[name] = value;
      }
      return ele;
    });
    setList(arr);
  };

  const packagePriceHandler = (id, name, value) => {
    const arr = packageArr?.map((ele, index) => {
      if (id === index) {
        ele[name] = value;
      }
      return ele;
    });
    setPackageArr(arr);
  };

  useEffect(() => {
    if (paymentDetails?.advanceFor === "PACKAGE") {
      setTestOrPackage("PACKAGE");
      const arr = payoutReducer?.getInsurerPackageDetail?.lstPackage?.map(
        (ele, index) => ele
      );
      setPackageArr(arr);
      const arr1 = payoutReducer?.getInsurerPackageDetail?.lstPackage?.filter(
        (ele, index) => {
          if (ele?.amount > 0 && ele?.isPreExistAmount === true) {
            return ele;
          }
        }
      );
      setCheckedPt(arr1);
    } else if (
      paymentDetails?.advanceFor === "TEST" &&
      payoutReducer?.getInsurerPackageDetail?.lstPackage?.length === 0
    ) {
      setTestOrPackage("TEST");
      const arr = payoutReducer?.getInsurerPackageDetail?.lstTest?.map(
        (ele) => ele
      );
      setPackageArr(arr);

      const arr1 = payoutReducer?.getInsurerPackageDetail?.lstTest?.filter(
        (ele) => {
          if (ele?.amount > 0 && ele?.isPreExistAmount === true) {
            return ele;
          }
        }
      );
      setCheckedPt(arr1);
    } else if (
      paymentDetails?.advanceFor === "TEST" &&
      payoutReducer?.getInsurerPackageDetail?.lstPackage?.length > 0
    ) {
      setTestOrPackage("ADDTEST");
      const arr = payoutReducer?.getInsurerPackageDetail?.lstPackage?.map(
        (ele) => ele
      );
      setPackageArr(arr);

      const arr4 = payoutReducer?.getInsurerPackageDetail?.lstPackage?.filter(
        (ele) => {
          if (ele?.amount > 0 && ele?.isPreExistAmount === true) {
            return ele;
          }
        }
      );
      const arr1 = payoutReducer?.getInsurerPackageDetail?.lstPackage?.map(
        (ele, index) => {
          return payoutReducer?.getInsurerPackageDetail?.lstPackage[
            index
          ]?.lstPackageTests?.map((item) => {
            return item;
          });
        }
      );
      setList(arr1.flat());
      const arr5 = arr1.flat().filter((ele) => {
        if (ele?.amount > 0 && ele?.isPreExistAmount === true) {
          return ele;
        }
      });

      const arr3 = payoutReducer?.getInsurerPackageDetail?.lstTest?.map(
        (ele) => ele
      );
      setAddTest(arr3);

      const arr6 = payoutReducer?.getInsurerPackageDetail?.lstTest?.filter(
        (ele) => {
          if (ele?.amount > 0 && ele?.isPreExistAmount === true) {
            return ele;
          }
        }
      );
      setCheckedPt([...arr4, ...arr6, ...arr5]);
    }
  }, [payoutReducer?.getInsurerPackageDetail]);

  useEffect(() => {
    console.log("advanceFor useEffevt", paymentDetails?.advanceFor);
    if (paymentDetails?.advanceFor) {
      dispatch(
        GetInsurerSysChargeOrAdvAmount({
          caseNo: paymentDetails?.caseNo,
          paymentFor: paymentDetails?.paymentFor,
          advanceFor: paymentDetails?.advanceFor,
          providerid: paymentDetails?.providerId,
          appointmentId: paymentDetails?.appointmentId,
        })
      );
    }
  }, [paymentDetails?.advanceFor]);

  useEffect(() => {
    let sum = 0;

    let sum2 = checkedPt?.forEach((ele) => {
      sum = sum + +ele?.amount;
    });
    if (
      checkedPt?.length === 0 &&
      (paymentDetails?.advanceFor === "TEST" ||
        paymentDetails?.advanceFor === "PACKAGE")
    ) {
      setAdvInsAmount(0);
    } else if (checkedPt?.length > 0) {
      setAdvInsAmount(sum);
    } else if (paymentDetails?.advanceFor === "ENTIRE CASE") {
      setPaymentDetails({
        ...paymentDetails,
        advInsAmount:
          payoutReducer?.getInsurerPackageDetail?.lstPackage[0]?.amount,
      });
      setAdvInsAmount(
        payoutReducer?.getInsurerPackageDetail?.lstPackage[0]?.amount
      );
    }
  }, [
    payoutReducer?.getInsurerPackageDetail,
    checkedPt,
    list,
    packageArr,
    addTest,
  ]);

  useEffect(() => {
    console.log("paymentDetails filePathfilePathfilePath", paymentDetails);

    if (paymentDetails?.filePath && !insurerFile && dcFiles !== "DCFile") {
      let resultIndex = paymentDetails?.filePath?.lastIndexOf("/");
      let result = paymentDetails?.filePath?.substring(
        resultIndex + 1,
        paymentDetails?.filePath?.length
      );
      console.log("file Insuer", paymentDetails?.filePath);
      console.log("file resultpath", result, resultIndex);
      setInsurerFile({
        name: result,
        filePath: paymentDetails?.filePath,
      });
      // setInsurerFile(paymentDetails?.filePath);
    }

    if (
      paymentDetails?.insurerFilePath &&
      !insurerAttachments &&
      networkFiles !== "InsurerFile"
    ) {
      let resultIndex = paymentDetails?.insurerFilePath?.lastIndexOf("/");
      let result = paymentDetails?.insurerFilePath?.substring(
        resultIndex + 1,
        paymentDetails?.insurerFilePath?.length
      );
      setInsurerAttachments({
        name: result,
        insurerFilePath: paymentDetails?.insurerFilePath,
      });
    }

    if (
      paymentDetails?.qrCodeFilePath &&
      !qRCodeAttachments &&
      financeFiles !== "QRCodeFile"
    ) {
      let resultIndex = paymentDetails?.qrCodeFilePath?.lastIndexOf("/");
      let result = paymentDetails?.qrCodeFilePath?.substring(
        resultIndex + 1,
        paymentDetails?.qrCodeFilePath?.length
      );
      console.log("health assure", paymentDetails?.qrCodeFilePath);
      console.log("file resultpath", result, resultIndex);
      setQRCodeAttachments({
        name: result,
        qrCodeFilePath: paymentDetails?.qrCodeFilePath,
      });
    }
  }, [paymentDetails]);

  useEffect(() => {
    console.log("insurer file", insurerFile);
  }, [insurerFile]);

  useEffect(() => {
    onChangeHandler("advancedInsurerAmt", advInsAmount);
  }, [advInsAmount]);

  useEffect(() => {
    setUserRoleCode(localStorage.getItem("userRoleCode"));
  }, []);

  const [showPopup, setShowPopup] = useState(false);
  const popupStyle = {
    position: "fixed",
    top: "20%",
    left: "50%",
    transform: "translate(-20%, -20%)",
    backgroundColor: "white",
    padding: "20px",
    boxShadow: "0 40px 80px rgba(0, 0, 0, 0.2)",
    zIndex: 1000,
    height: "180px",
    width: "450px",
  };
  const handleButtonClick = () => {
    setShowPopup(true);
  };
  const handleRejectChanges = async (response) => {
    console.log("response", response);
    if (response === "Yes") {
      setIsRejectRemarks(true);
      console.log("reject remarks", isRejectRemarks);
      const reject = {
        AppointmentId: paymentDetails?.appointmentId,
        ProviderId: paymentDetails?.providerId,
        AdvPaymentStatus: paymentDetails?.advPaymentStatus,
        Remarks: paymentDetails?.rejectRemarks,
      };
      console.log("reject Payload", reject);
      if (
        reject.Remarks === "" ||
        reject?.Remarks === undefined ||
        reject?.Remarks === null
      ) {
        const actionType = paymentDetails?.advPaymentStatus === "Pending At Manager" ? "cancelling" : "rejecting";

        getSnackbarSuccess(
          "info",
          `Please specify the reason for ${actionType} this request`,
          dispatch
        );
        setShowPopup(false);
      } else {
        const rejRes = await dispatch(
          EverGreenPOSTApi(reject, "CancelOrRejectAdvancePaymentFlow")
        );

        getSnackbarSuccess(
          rejRes?.data?.status === true ? "success" : "error",
          rejRes?.data?.message,
          dispatch
        );
        if (rejRes?.data?.status === true) {
          setTimeout(async () => {
            await handleSearch();
          }, 1000);

          backRef?.current?.click();
          setShowPopup(false);
        }

        console.log("resss", rejRes);
      }
      setIsRejectRemarks(false);
    } else {
      setShowPopup(false);
    }
  };

  const handleSaveChanges = async (e) => {
    e.preventDefault();

    setIsRejectRemarks(false);
    console.log("isRejectRemarks", isRejectRemarks);

    const arr = checkedPt.map((ele) => {
      return {
        isPackage: testOrPackage === "PACKAGE" ? 1 : 0,
        isAdvanceFor: paymentDetails?.advanceFor,
        appointmentId: paymentDetails?.appointmentId,
        amount: ele?.amount.toString(),
        clientId: ele?.clientId,
        packageId: ele?.packageId,
        packageName: ele?.packageName,
        testId: ele?.testId,
        testName: ele?.testName,
        type: ele?.type,
      };
    });

    const fromData = new FormData();
    fromData.append("InsurerAdvanceAmountDetails", JSON.stringify(arr));
    fromData.append("AdvanceAmountDetails", JSON.stringify(arr));
    fromData.append("Attachments", insurerFile?.filePath ? null : insurerFile);
    fromData.append("IsInsurerFile", true);
    fromData.append("AppointmentId", paymentDetails?.appointmentId);
    fromData.append("ProviderId", paymentDetails?.providerId);
    fromData.append("AdvPaymentStatus", paymentDetails?.advPaymentStatus);
    fromData.append("AdvancedDCAmt", paymentDetails?.advancedDCAmt);
    fromData.append("AdvancedInsurerAmt", paymentDetails?.advancedInsurerAmt);
    fromData.append("UTR", paymentDetails?.utr);
    fromData.append("Remarks", paymentDetails?.remarks);
    fromData.append("PaymentType", paymentDetails?.paymentType);
    fromData.append("PaymentFor", paymentDetails?.paymentFor);
    fromData.append("HVPaymentFor", paymentDetails?.hvPaymentFor);
    fromData.append(
      "InsurerHVAmount",
      paymentDetails?.advanceInsurerHomeVisitAmount
        ? paymentDetails?.advanceInsurerHomeVisitAmount
        : 0
    );
    fromData.append("AdvanceFor", paymentDetails?.advanceFor);
    fromData.append("ApproverName", paymentDetails?.approverName);
    fromData.append("InsurerRemarks", paymentDetails?.insurerRemarks);
    fromData.append(
      "InsurerAttachments",
      insurerAttachments?.insurerFilePath ? null : insurerAttachments
    );
    fromData.append(
      "QRCodeAttachments",
      qRCodeAttachments?.qrCodeFilePath ? null : qRCodeAttachments
    );
    fromData.append("PaymentMode", paymentDetails?.paymentMode);

    fromData.append("MobileNumber", paymentDetails?.mobileNumber);
    fromData.append("AccountNumber", paymentDetails?.accountNumber);
    fromData.append("BankName", paymentDetails?.bankName);
    fromData.append("IFSCCode", paymentDetails?.ifscCode);
    fromData.append("payeeName", paymentDetails?.payeeName);
    fromData.append("PaymentRemarks", paymentDetails?.paymentRemarks);
    fromData.append("PanNumber", paymentDetails?.panNumber);

    if (
      paymentDetails?.advPaymentStatus === "Pending At Network" ||
      paymentDetails?.advPaymentStatus === "Pending At Network Account" ||
      paymentDetails?.advPaymentStatus === "Pending At Finance"
    ) {
      fromData.append("TDSFlag", paymentDetails?.tdsFlag);
      fromData.append("LastUpdatedDate", paymentDetails?.lastUpdatedDate);
      fromData.append("PaymentDate", paymentDetails?.paymentDate);
    }
    if (paymentDetails?.advPaymentStatus === "Pending At Finance") {
      fromData.append("TDSPercentage", paymentDetails?.tdsPercentage);
      fromData.append("TDSAmount", paymentDetails?.tdsAmount);
      fromData.append("NetAmount", paymentDetails?.netAmount);
    }

    const ress = await dispatch(
      EverGreenPOSTApi(fromData, "AddUpdateAdvancePaymentFlowNetwork")
    );

    getSnackbarSuccess(
      ress?.data?.status === true ? "success" : "error",
      ress?.data?.message,
      dispatch
    );
    if (ress?.data?.status === true) {
      setTimeout(async () => {
        await handleSearch();
      }, 1000);

      backRef?.current?.click();
    }

    console.log("resss", ress);
  };
  const informationPermissions = JSON.parse(
    localStorage.getItem("NetworkMenuId")
  )["informationPermissions"];

  const [IsAccountVisible, setIsAccountVisible] = useState(true);

  const onhandlerAccountInfo = (e) => {
    setIsAccountVisible(false);
  };

  const [isDisable, setIsDisable] = useState(false);
  const [isPendingAtManager, setIsPendingAtManager] = useState(false);
  const [isPendingAtNetwork, setIsPendingAtNetwork] = useState(false);
  const [isPendingAtNetworkAccount, setIsPendingAtNetworkAccount] =
    useState(false);
  const [isPendingAtFinance, setIsPendingAtFinance] = useState(false);
  const [isRejectRemarks, setIsRejectRemarks] = useState(false);

  useEffect(() => {
    const index = informationPermissions
      ?.filter((i) => i?.canEdit === true)
      .findIndex(
        (ele) => ele?.informationName === paymentDetails?.advPaymentStatus
      );
    console.log("index", index);
    setIsDisable(index !== -1 ? false : true);

    const index2 = informationPermissions
      ?.filter((i) => i?.canView === true || i?.canEdit === true)
      .findIndex((ele) => ele?.informationName === "Pending At Manager");

    setIsPendingAtManager(index2 !== -1 ? true : false);

    const index3 = informationPermissions
      ?.filter((i) => i?.canEdit === true || i?.canView === true)
      .findIndex((ele) => ele?.informationName === "Pending At Network");

    setIsPendingAtNetwork(index3 !== -1 ? true : false);

    const index4 = informationPermissions
      ?.filter((i) => i?.canEdit === true || i?.canView === true)
      .findIndex(
        (ele) => ele?.informationName === "Pending At Network Account"
      );

    setIsPendingAtNetworkAccount(index4 !== -1 ? true : false);

    const index5 = informationPermissions
      ?.filter((i) => i?.canEdit === true || i?.canView === true)
      .findIndex((ele) => ele?.informationName === "Pending At Finance");

    setIsPendingAtFinance(index5 !== -1 ? true : false);
  }, [paymentDetails]);

  return (
    <>
      <div className="" style={{ padding: "20px" }}>
        <div className=" justify-content-between">
          <div
            className="back-buttondiv"
            ref={backRef}
            onClick={() => {
              setScreen("first");
              setPaymentDetails(null);
            }}
          >
            <i className="fa-solid fa-circle-arrow-left"></i>
            <h6 style={{ cursor: "pointer" }}>Back</h6>
          </div>
        </div>

        <div className=" staff-details-section mt20">
          <div className="card-body" style={{ padding: "12px" }}>
            <div className="custom-container">
              <form onSubmit={handleSaveChanges}>
                {(isPendingAtManager ||
                  isPendingAtNetwork ||
                  isPendingAtNetworkAccount ||
                  isPendingAtFinance) && (
                  <div>
                    <div className="row">
                      <h4
                        className="font-bold text-highlight mb-4"
                        style={{ letterSpacing: "1px" }}
                      >
                        Provider Advance Payout
                      </h4>

                      <div className="col-lg-3 col-md-5 mt-4">
                        <label className="col-form-label">Case No.</label>
                        <div class="input-group mb-2 mr-sm-2">
                          <input
                            type="text"
                            class="form-control"
                            id="inlineFormInputGroupUsername2"
                            style={{ padding: "7px" }}
                            value={paymentDetails?.caseNo}
                            disabled
                            onKeyPress={(event) => {
                              if (event.key === " ") {
                                event.preventDefault();
                              }
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-5 mt-4">
                        <label className="col-form-label">
                          Provider Name
                          {/*<MandatoryStar />*/}
                        </label>
                        <select
                          class="form-select p-2 b"
                          value={paymentDetails?.providerId}
                          style={{ backgroundColor: "#EEEEEE" }}
                          required
                          onChange={(e) => {}}
                          disabled
                        >
                          {/* <option value="">Select Provider</option> */}
                          {[
                            {
                              providerId: paymentDetails?.providerId,
                              providerName: paymentDetails?.providerName,
                            },
                          ]?.map((ele) => {
                            return (
                              <option value={ele?.providerId}>
                                {ele?.providerName}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      <div class=" col-lg-3 col-md-5  mt-4 ">
                        <label className="col-form-label">
                          Centre Name
                          {/* <MandatoryStar /> */}
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          style={{ padding: "7px" }}
                          // id="inlineFormInputGroupUsername2"
                          placeholder="Centre Name"
                          value={paymentDetails?.centreName}
                          disabled={true}
                          // min={1}
                          required
                          //   onChange={(e) =>
                          //     changeHandler("clientName", e.target.value)
                          //   }
                        />
                      </div>
                      <div className="col-lg-3 col-md-5 mt-4">
                        <label className="col-form-label">
                          Payment Type
                          {/* <MandatoryStar /> */}
                        </label>
                        <select
                          class="form-select p-2"
                          style={{ backgroundColor: "#EEEEEE" }}
                          value={paymentDetails?.paymentType}
                          disabled
                          required
                          onChange={(e) =>
                            onChangeHandler("paymentType", e.target.value)
                          }
                        >
                          <option value={""}> Select Payment Type</option>
                          <option value={"Advance Paid"}>Advance Paid</option>
                          <option value={"Refund"}>Refund </option>
                          <option value={"Partial Refund"}>
                            Partial Refund{" "}
                          </option>
                          <option value={"Payment Lost"}>Payment Lost </option>
                        </select>
                      </div>
                      <div class=" col-lg-3 col-md-5 mt-4">
                        <label className="col-form-label">
                          Adv DC Amount
                          <MandatoryStar />
                        </label>
                        <input
                          type="number"
                          class="form-control"
                          style={{ padding: "7px" }}
                          id="inlineFormInputGroupUsername2"
                          placeholder="Enter Amount"
                          value={paymentDetails?.advancedDCAmt}
                          min={1}
                          required
                          disabled={isPendingAtFinance ? true : false}
                          onChange={(e) =>
                            onChangeHandler("advancedDCAmt", e.target.value)
                          }
                        />
                      </div>
                      <div class=" col-lg-3 col-md-5 mt-4">
                        <label className="col-form-label">
                          Remarks
                          {/* <MandatoryStar /> */}
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          style={{ padding: "7px" }}
                          id="inlineFormInputGroupUsername2"
                          placeholder="Enter Remarks"
                          value={paymentDetails?.remarks}
                          disabled={isPendingAtFinance ? true : false}
                          onChange={(e) =>
                            onChangeHandler(
                              "remarks",
                              e.target.value.trimStart()
                            )
                          }
                        />
                      </div>
                      <div class=" col-lg-3 col-md-5 mt-4">
                        <label className="col-form-label">
                          Approver Name
                          <MandatoryStar />
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          style={{ padding: "7px" }}
                          id="inlineFormInputGroupUsername2"
                          placeholder="Approver Name"
                          value={paymentDetails?.approverName}
                          disabled={isPendingAtFinance ? true : false}
                          required
                          onChange={(e) =>
                            onChangeHandler(
                              "approverName",
                              e.target.value.trimStart()
                            )
                          }
                        />
                      </div>
                      <div className="col-lg-3 col-md-5 mt-4">
                        <label className="col-form-label">Upload Report</label>
                        {insurerFile === null && (
                          <input
                            type="file"
                            disabled={isPendingAtFinance ? true : false}
                            onChange={(e) => {
                              const file = e.target.files[0];

                              if (
                                file.type !== "image/png" &&
                                file.type !== "image/PNG" &&
                                file.type !== "image/jpg" &&
                                file.type !== "image/JPG" &&
                                file.type !== "image/JPEG" &&
                                file.type !== "image/jpeg" &&
                                file.type !== "application/pdf" &&
                                file.type !== "application/pdf"
                              ) {
                                getSnackbarSuccess(
                                  "error",
                                  "Only PNG,JPG,JPEG and PDF is allowed",
                                  dispatch
                                );
                                e.target.value = null;
                                return;
                              } else {
                                setInsurerFile(file);
                                setdcFiles(null);
                                // uploadDcoument(file, true,"insurer");
                              }
                            }}
                            className="form-control form-select-admin inputbgavanish serviceicon"
                          />
                        )}

                        {insurerFile !== null && (
                          <label className="d-flex justify-content-between form-control form-select-admin inputbgavanish">
                            <a
                              href={insurerFile?.filePath}
                              target="_blank"
                              className="serviceImagename"
                              style={{ color: "black" }}
                            >
                              {insurerFile?.name}
                            </a>
                            {!isDisable &&
                              (paymentDetails?.advPaymentStatus ===
                                "Pending At Network" ||
                                paymentDetails?.advPaymentStatus ===
                                  "Pending At Network Account" ||
                                paymentDetails?.advPaymentStatus ===
                                  "Pending At Manager") && (
                                <span
                                  // onClick={() => {
                                  //   setInsurerFile(null);
                                  // }}

                                  onClick={async () => {
                                    await dispatch(
                                      deleteAdvancePaymentFiles({
                                        appointmentId:
                                          paymentDetails.appointmentId,
                                        dcFiles: "DCFile",
                                      })
                                    );
                                    setInsurerFile(null);
                                    setdcFiles("DCFile");
                                  }}
                                >
                                  <img src="https://live.healthassure.in/ProvidersPortal/images/removeicon.png" />
                                </span>
                              )}
                          </label>
                        )}
                      </div>
                    </div>

                    <div className="row">
                      <h4
                        className="font-bold text-highlight mb-4"
                        style={{ letterSpacing: "1px" }}
                      >
                        Insurer Billing
                      </h4>
                      <div class=" col-lg-3 col-md-5  mt-4 ">
                        <label className="col-form-label">
                          Insurer Name
                          {/* <MandatoryStar /> */}
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          style={{ padding: "7px" }}
                          placeholder="Insurer Name"
                          value={paymentDetails?.clientName}
                          disabled={true}
                          required
                        />
                      </div>
                      <div className="col-lg-3 col-md-5 mt-4">
                        <label className="col-form-label">
                          Payment For <MandatoryStar />
                        </label>
                        <select
                          class="form-select p-2"
                          value={paymentDetails?.paymentFor}
                          required
                          disabled={isPendingAtFinance ? true : false}
                          onChange={async (e) => {
                            onChangeHandler("paymentFor", null);
                            if (e.target.value === "Syscharge") {
                              const ress = await dispatch(
                                GetInsurerSysChargeOrAdvAmount({
                                  caseNo: paymentDetails?.caseNo,
                                  paymentFor: "Syscharge",
                                  advanceFor: "",
                                  providerid: paymentDetails?.providerId,
                                  appointmentId: paymentDetails.appointmentId,
                                })
                              );
                              console.log("ress222", ress);
                              paymentDetails["advancedInsurerAmt"] =
                                ress?.data?.results?.lstPackage?.length > 0
                                  ? ress?.data?.results?.lstPackage[0].amount
                                  : 0;
                              // if(e.target.value==="Syscharge"){
                              //   paymentDetails["advanceFor"]="";
                              // }
                              await onChangeHandler(
                                "paymentFor",
                                e.target.value
                              );

                              console.log("ress", ress);
                            } else {
                              paymentDetails["advancedInsurerAmt"] = "";
                              onChangeHandler("paymentFor", e.target.value);
                            }
                          }}
                        >
                          <option value={""}> Select Payment For</option>
                          <option value={"Syscharge"}>Existing Rate</option>
                          <option value={"AdvaAmt"}>Exceptional Rate</option>
                        </select>
                      </div>
                      {paymentDetails?.paymentFor === "AdvaAmt" && (
                        <div className="col-lg-3 col-md-5 mt-4">
                          <label className="col-form-label">
                            Advance For <MandatoryStar />
                          </label>
                          <select
                            class="form-select p-2"
                            value={paymentDetails?.advanceFor}
                            required
                            disabled={isPendingAtFinance ? true : false}
                            onChange={async (e) => {
                              setList([]);
                              setPackageArr([]);
                              setCheckedPt([]);
                              setAddTest([]);
                              getDispatch(
                                GET_INSURER_TEST_PACKAGE_DETAIL,
                                null,
                                dispatch
                              );

                              //handleInsurerPackageDetails(ress?.data?.results, e.target.value)
                              onChangeHandler("advanceFor", e.target.value);
                            }}
                          >
                            <option value=""> Select Advance For</option>
                            <option value={"ENTIRE CASE"}>ENTIRE CASE</option>
                            <option value={"PACKAGE"}>PACKAGE </option>
                            <option value={"TEST"}>TEST</option>
                          </select>
                        </div>
                      )}

                      <div class=" col-lg-3 col-md-5 mt-4">
                        <label className="col-form-label">
                          Adv Insurer Amount
                          <MandatoryStar />
                        </label>
                        <input
                          type="number"
                          class="form-control"
                          style={{ padding: "7px" }}
                          id="inlineFormInputGroupUsername2"
                          placeholder="Enter Amount"
                          value={paymentDetails?.advancedInsurerAmt}
                          min={1}
                          disabled={
                            paymentDetails?.paymentFor === "Syscharge" ||
                            paymentDetails?.advanceFor === "PACKAGE" ||
                            paymentDetails?.advanceFor === "TEST" ||
                            isPendingAtFinance
                              ? true
                              : false
                          }
                          required
                          onChange={(e) =>
                            onChangeHandler(
                              "advancedInsurerAmt",
                              e.target.value
                            )
                          }
                        />
                      </div>
                      <div className="col-lg-3 col-md-5 mt-4">
                        <label className="col-form-label">
                          HV Payment For
                          {paymentDetails?.isHomeVisit === "Y" && (
                            <MandatoryStar />
                          )}
                        </label>
                        <select
                          class="form-select p-2"
                          value={paymentDetails?.hvPaymentFor}
                          required={paymentDetails?.isHomeVisit === "Y"}
                          disabled={isPendingAtFinance ? true : false}
                          onChange={async (e) => {
                            onChangeHandler("hvPaymentFor", null);
                            if (e.target.value === "Syscharge") {
                              const ress = await dispatch(
                                EverGreenPOSTApi(
                                  {
                                    caseNo: paymentDetails?.caseNo,
                                    hVpaymentFor: e.target.value,
                                    providerid: paymentDetails?.providerId,
                                  },
                                  "GetAdvancePaymentSysChargeHVAmount"
                                )
                              );

                              console.log("ress", ress);
                              paymentDetails["advanceInsurerHomeVisitAmount"] =
                                ress?.data?.results[0]
                                  ? ress?.data?.results[0]
                                  : 0;

                              onChangeHandler("hvPaymentFor", e.target.value);
                            } else {
                              paymentDetails["advanceInsurerHomeVisitAmount"] =
                                "";
                              onChangeHandler("hvPaymentFor", e.target.value);
                            }
                          }}
                        >
                          <option value={""}> Select HV Payment For</option>
                          <option value={"Syscharge"}>Existing Rate</option>
                          <option value={"AdvaAmt"}>Exceptional Rate</option>
                        </select>
                      </div>

                      <div class=" col-lg-3 col-md-5 mt-4">
                        <label className="col-form-label">
                          Adv HV Amount
                          {paymentDetails?.isHomeVisit === "Y" && (
                            <MandatoryStar />
                          )}
                        </label>
                        <input
                          type="number"
                          class="form-control"
                          style={{ padding: "7px" }}
                          id="inlineFormInputGroupUsername2"
                          placeholder="Enter Amount"
                          value={paymentDetails?.advanceInsurerHomeVisitAmount}
                          min={1}
                          disabled={
                            paymentDetails?.hvPaymentFor === "Syscharge" ||
                            isPendingAtFinance
                              ? true
                              : false
                          }
                          required={paymentDetails?.isHomeVisit === "Y"}
                          onChange={(e) =>
                            onChangeHandler(
                              "advanceInsurerHomeVisitAmount",
                              e.target.value
                            )
                          }
                        />
                      </div>
                      <div class=" col-lg-3 col-md-5 mt-4">
                        <label className="col-form-label">
                          Insurer Remarks
                          {/* <MandatoryStar /> */}
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          style={{ padding: "7px" }}
                          id="inlineFormInputGroupUsername2"
                          placeholder="Enter Remarks"
                          value={paymentDetails?.insurerRemarks}
                          disabled={isPendingAtFinance ? true : false}
                          onChange={(e) =>
                            onChangeHandler(
                              "insurerRemarks",
                              e.target.value.trimStart()
                            )
                          }
                        />
                      </div>
                      <div className="col-lg-3 col-md-5 mt-4">
                        <label className="col-form-label">Upload Report</label>
                        {insurerAttachments === null && (
                          <input
                            type="file"
                            disabled={isPendingAtFinance ? true : false}
                            onChange={(e) => {
                              const insfile = e.target.files[0];

                              if (
                                insfile.type !== "image/png" &&
                                insfile.type !== "image/PNG" &&
                                insfile.type !== "image/jpg" &&
                                insfile.type !== "image/JPG" &&
                                insfile.type !== "image/JPEG" &&
                                insfile.type !== "image/jpeg" &&
                                insfile.type !== "application/pdf" &&
                                insfile.type !== "application/pdf"
                              ) {
                                getSnackbarSuccess(
                                  "error",
                                  "Only PNG,JPG,JPEG and PDF is allowed",
                                  dispatch
                                );
                                e.target.value = null;
                                return;
                              } else {
                                setInsurerAttachments(insfile);
                                setnetworkFiles(null);
                                // uploadDcoument(file, true,"insurer");
                              }
                            }}
                            className="form-control form-select-admin inputbgavanish serviceicon"
                          />
                        )}

                        {insurerAttachments !== null && (
                          <label className="d-flex justify-content-between form-control form-select-admin inputbgavanish">
                            <a
                              href={insurerAttachments?.insurerFilePath}
                              target="_blank"
                              className="serviceImagename"
                              style={{ color: "black" }}
                            >
                              {insurerAttachments?.name}
                            </a>

                            {!isDisable &&
                              (paymentDetails?.advPaymentStatus ===
                                "Pending At Network" ||
                                paymentDetails?.advPaymentStatus ===
                                  "Pending At Network Account" ||
                                paymentDetails?.advPaymentStatus ===
                                  "Pending At Manager") && (
                                <span
                                  onClick={async () => {
                                    await dispatch(
                                      deleteAdvancePaymentFiles({
                                        appointmentId:
                                          paymentDetails.appointmentId,
                                        networkFiles: "InsurerFile",
                                      })
                                    );

                                    setInsurerAttachments(null);
                                    setnetworkFiles("InsurerFile");
                                  }}
                                >
                                  <img src="https://live.healthassure.in/ProvidersPortal/images/removeicon.png" />
                                </span>
                              )}
                          </label>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {(isPendingAtNetwork ||
                  isPendingAtNetworkAccount ||
                  isPendingAtFinance) &&
                  (paymentDetails?.advPaymentStatus === "Pending At Network" ||
                    paymentDetails?.advPaymentStatus ===
                      "Pending At Network Account" ||
                    paymentDetails.advPaymentStatus === "Pending At Finance" ||
                    paymentDetails.advPaymentStatus === "Payment Approved") && (
                    <div>
                      <div className="row">
                        <div>
                          <h4
                            className="font-bold text-highlight mb-4"
                            style={{ letterSpacing: "1px" }}
                          >
                            Provider Payout Details
                          </h4>
                        </div>
                        <div className="col-lg-3 col-md-5 mt-4">
                          <label className="col-form-label">
                            Payment Mode <MandatoryStar />
                          </label>
                          <select
                            class="form-select p-2"
                            value={paymentDetails?.paymentMode}
                            required
                            disabled={
                              paymentDetails?.advPaymentStatus ===
                                "Pending At Finance" && isPendingAtFinance
                                ? true
                                : false
                            }
                            onChange={(e) => {
                              onChangeHandler("paymentMode", e.target.value);
                            }}
                          >
                            <option value={""}> Select Payment Mode</option>
                            <option value={"NEFT"}>NEFT</option>
                            <option value={"QRCODE"}>QR CODE</option>
                          </select>
                        </div>
                        <div className="col-lg-3 col-md-5 mt-4">
                          <label className="col-form-label">
                            TDS
                            {isPendingAtNetworkAccount &&
                              paymentDetails?.advPaymentStatus ===
                                "Pending At Network Account" && (
                                <MandatoryStar />
                              )}
                          </label>
                          <select
                            class="form-select p-2"
                            value={paymentDetails?.tdsFlag}
                            required={
                              isPendingAtNetworkAccount &&
                              paymentDetails?.advPaymentStatus ===
                                "Pending At Network Account"
                                ? true
                                : false
                            }
                            disabled={
                              paymentDetails?.advPaymentStatus ===
                                "Pending At Finance" && isPendingAtFinance
                                ? true
                                : false
                            }
                            onChange={(e) => {
                              onChangeHandler("tdsFlag", e.target.value);
                            }}
                          >
                            <option value={""}> Select TDS</option>
                            <option value={"Y"}>Yes</option>
                            <option value={"N"}>No</option>
                          </select>
                        </div>

                        <div className="col-lg-3 col-md-5 mt-4">
                          <label className="col-form-label">
                            Mobile Number / UPI ID
                            <MandatoryStar />
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            minLength={10}
                            maxLength={50}
                            style={{ padding: "7px" }}
                            onKeyDown={(e) => {
                              if (e.key === " " || e.key === "+") {
                                e.preventDefault(); // Prevent entering a space, minus sign, or plus sign
                              }
                            }}
                            onKeyPress={(event) => {
                              const re = /^[a-zA-Z0-9.@-]*$/g;
                              if (!re.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            placeholder="Mobile Number"
                            value={paymentDetails?.mobileNumber}
                            required
                            disabled={
                              paymentDetails?.advPaymentStatus ===
                                "Pending At Finance" && isPendingAtFinance
                                ? true
                                : false
                            }
                            onChange={(e) => {
                              onChangeHandler("mobileNumber", e.target.value);
                            }}
                          />
                        </div>
                      </div>

                      {paymentDetails?.paymentMode === "NEFT" && (
                        <div className="row">
                          <div className="col-lg-3 col-md-5 mt-4">
                            <label className="col-form-label">
                              Account Number <MandatoryStar />
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              style={{ padding: "7px" }}
                              placeholder="Account Number"
                              value={paymentDetails?.accountNumber}
                              required
                              // disabled={isPendingAtFinance?true:false}
                              disabled={IsAccountVisible ? true : false}
                              onChange={(e) => {
                                onChangeHandler(
                                  "accountNumber",
                                  e.target.value.trimStart()
                                );
                              }}
                            />
                          </div>
                          <div className="col-lg-3 col-md-5 mt-4">
                            <label className="col-form-label">
                              Bank Name <MandatoryStar />
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              style={{ padding: "7px" }}
                              placeholder="Account Number"
                              value={paymentDetails?.bankName}
                              required
                              // disabled={isPendingAtFinance?true:false}
                              disabled={IsAccountVisible ? true : false}
                              onChange={(e) => {
                                onChangeHandler(
                                  "bankName",
                                  e.target.value.trimStart()
                                );
                              }}
                            />
                          </div>
                          <div className="col-lg-3 col-md-5 mt-4">
                            <label className="col-form-label">
                              IFSC Code <MandatoryStar />
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              style={{ padding: "7px" }}
                              placeholder="IFSC Code"
                              value={paymentDetails?.ifscCode}
                              required
                              // disabled={isPendingAtFinance?true:false}
                              disabled={IsAccountVisible ? true : false}
                              onChange={(e) => {
                                onChangeHandler(
                                  "ifscCode",
                                  e.target.value.trimStart()
                                );
                              }}
                            />
                          </div>
                          <div className="col-lg-3 col-md-5 mt-4">
                            <label className="col-form-label">
                              Payee Name <MandatoryStar />
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              style={{ padding: "7px" }}
                              placeholder="Payee Name"
                              value={paymentDetails?.payeeName}
                              required
                              // disabled={(paymentDetails?.advPaymentStatus==="Pending At Finance" && isPendingAtFinance)?true:false}
                              disabled={IsAccountVisible ? true : false}
                              onChange={(e) => {
                                onChangeHandler(
                                  "payeeName",
                                  e.target.value.trimStart()
                                );
                              }}
                            />
                          </div>
                          <div className="col-lg-3 col-md-5 mt-4">
                            <label className="col-form-label">
                              PAN Number <MandatoryStar />
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              style={{ padding: "7px" }}
                              placeholder="PAN Number"
                              value={paymentDetails?.panNumber}
                              required
                              // disabled={(paymentDetails?.advPaymentStatus==="Pending At Finance" && isPendingAtFinance)?true:false}
                              disabled={IsAccountVisible ? true : false}
                              onChange={(e) => {
                                onChangeHandler(
                                  "panNumber",
                                  e.target.value.trimStart()
                                );
                              }}
                            />
                          </div>
                          <div className="col-lg-2 col-md-4 mt-3">
                            <label className="col-form-label">
                              Last Updated Date <MandatoryStar />
                            </label>
                            <input
                              type="date"
                              class="white-form-select"
                              style={{ padding: "7px", marginTop: "10px" }}
                              placeholder="Last Updated Date"
                              data-date-format="DD MMMM YYYY"
                              value={paymentDetails?.lastUpdatedDate}
                              required
                              disabled={
                                paymentDetails?.advPaymentStatus ===
                                  "Pending At Finance" && isPendingAtFinance
                                  ? true
                                  : false
                              }
                              max={new Date().toISOString().split("T")[0]}
                              onChange={(e) => {
                                onChangeHandler(
                                  "lastUpdatedDate",
                                  e.target.value
                                );
                              }}
                            />
                          </div>
                          <div className="col-lg-1 col-md-1 mt-1">
                            <button
                              className="input-group-text search"
                              type="button"
                              style={{
                                cursor: "pointer",
                                marginTop: "60px",
                                height: "30px",
                              }}
                              disabled={
                                paymentDetails?.advPaymentStatus ===
                                  "Pending At Finance" && isPendingAtFinance
                                  ? true
                                  : false
                              }
                              onClick={onhandlerAccountInfo}
                            >
                              {" "}
                              Edit
                            </button>
                          </div>
                        </div>
                      )}

                      {paymentDetails?.paymentMode === "QRCODE" &&
                        paymentDetails.advPaymentStatus !==
                          "Pending At Finance" && (
                          <div className="row">
                            <div className="col-lg-3 col-md-5 mt-4">
                              <label className="col-form-label">
                                Upload QR Code <MandatoryStar />{" "}
                              </label>
                              {qRCodeAttachments === null && (
                                <input
                                  type="file"
                                  required
                                  onChange={(e) => {
                                    const file = e.target.files[0];

                                    if (
                                      file.type !== "image/png" &&
                                      file.type !== "image/PNG" &&
                                      file.type !== "image/jpg" &&
                                      file.type !== "image/JPG" &&
                                      file.type !== "image/JPEG" &&
                                      file.type !== "image/jpeg" &&
                                      file.type !== "application/pdf" &&
                                      file.type !== "application/pdf"
                                    ) {
                                      getSnackbarSuccess(
                                        "error",
                                        "Only PNG,JPG,JPEG and PDF is allowed",
                                        dispatch
                                      );
                                      e.target.value = null;
                                      return;
                                    } else {
                                      setQRCodeAttachments(file);
                                      setfinanceFiles(null);
                                      // uploadDcoument(file, true,"insurer");
                                    }
                                  }}
                                  className="form-control form-select-admin inputbgavanish serviceicon"
                                />
                              )}

                              {qRCodeAttachments !== null && (
                                <label className="d-flex justify-content-between form-control form-select-admin inputbgavanish">
                                  <a
                                    href={qRCodeAttachments?.qrCodeFilePath}
                                    target="_blank"
                                    className="serviceImagename"
                                    style={{ color: "black" }}
                                  >
                                    {qRCodeAttachments?.name}
                                  </a>

                                  {!isDisable && (
                                    <span
                                      onClick={async () => {
                                        await dispatch(
                                          deleteAdvancePaymentFiles({
                                            appointmentId:
                                              paymentDetails.appointmentId,
                                            financeFiles: "QRCodeFile",
                                          })
                                        );
                                        setQRCodeAttachments(null);
                                        setfinanceFiles("QRCodeFile");
                                      }}
                                    >
                                      <img src="https://live.healthassure.in/ProvidersPortal/images/removeicon.png" />
                                    </span>
                                  )}
                                </label>
                              )}
                            </div>
                            {paymentDetails.advPaymentStatus !==
                              "Pending At Finance" && (
                              <div class=" col-lg-3 col-md-5 mt-4">
                                <label className="col-form-label">
                                  Remarks
                                  {/* <MandatoryStar /> */}
                                </label>
                                <input
                                  type="text"
                                  class="form-control"
                                  style={{ padding: "7px" }}
                                  id="inlineFormInputGroupUsername2"
                                  placeholder="Enter Remarks"
                                  value={paymentDetails?.paymentRemarks}
                                  disabled={
                                    paymentDetails?.advPaymentStatus ===
                                      "Pending At Finance" && isPendingAtFinance
                                      ? true
                                      : false
                                  }
                                  onChange={(e) =>
                                    onChangeHandler(
                                      "paymentRemarks",
                                      e.target.value
                                    )
                                  }
                                />
                              </div>
                            )}
                            {paymentDetails.advPaymentStatus !==
                              "Pending At Finance" && (
                              <div class=" col-lg-3 col-md-5 mt-4">
                                <label className="col-form-label">
                                  UTR No{" "}
                                  {isPendingAtNetworkAccount &&
                                    paymentDetails?.advPaymentStatus ===
                                      "Pending At Network Account" && (
                                      <MandatoryStar />
                                    )}
                                </label>
                                <input
                                  type="text"
                                  class="form-control"
                                  style={{ padding: "7px" }}
                                  id="inlineFormInputGroupUsername2"
                                  placeholder="UTR No"
                                  value={paymentDetails?.utr}
                                  required={
                                    isPendingAtNetworkAccount &&
                                    paymentDetails?.advPaymentStatus ===
                                      "Pending At Network Account"
                                      ? true
                                      : false
                                  }
                                  disabled={
                                    paymentDetails?.advPaymentStatus ===
                                      "Pending At Finance" && isPendingAtFinance
                                      ? true
                                      : false
                                  }
                                  onChange={(e) =>
                                    onChangeHandler(
                                      "utr",
                                      e.target.value.trimStart()
                                    )
                                  }
                                />
                              </div>
                            )}
                            {paymentDetails.advPaymentStatus !==
                              "Pending At Finance" && (
                              <div className="col-lg-3 col-md-5 mt-4">
                                <label className="col-form-label">
                                  Payment Date{" "}
                                  {isPendingAtNetworkAccount &&
                                    paymentDetails?.advPaymentStatus ===
                                      "Pending At Network Account" && (
                                      <MandatoryStar />
                                    )}
                                </label>
                                <input
                                  type="date"
                                  class="white-form-select"
                                  style={{ padding: "7px" }}
                                  placeholder="Payment Date"
                                  data-date-format="DD MMMM YYYY"
                                  value={paymentDetails?.paymentDate}
                                  required={
                                    isPendingAtNetworkAccount &&
                                    paymentDetails?.advPaymentStatus ===
                                      "Pending At Network Account"
                                      ? true
                                      : false
                                  }
                                  disabled={
                                    paymentDetails?.advPaymentStatus ===
                                      "Pending At Finance" && isPendingAtFinance
                                      ? true
                                      : false
                                  }
                                  max={new Date().toISOString().split("T")[0]}
                                  onChange={(e) =>
                                    onChangeHandler(
                                      "paymentDate",
                                      e.target.value
                                    )
                                  }
                                />
                              </div>
                            )}
                          </div>
                        )}
                    </div>
                  )}

                {isPendingAtFinance &&
                  (paymentDetails.advPaymentStatus === "Pending At Finance" ||
                    paymentDetails.advPaymentStatus === "Payment Approved") && (
                    <div className="row">
                      {/* {isPendingAtFinance && paymentDetails?.advPaymentStatus==="Pending At Finance"  
                      && } */}
                      <h4
                        className="font-bold text-highlight mb-4"
                        style={{ letterSpacing: "1px", marginTop: "10px" }}
                      >
                        Payment Details
                      </h4>

                      <div class=" col-lg-3 col-md-5 mt-4">
                        <label className="col-form-label">
                          Remarks
                          {/* <MandatoryStar /> */}
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          style={{ padding: "7px" }}
                          id="inlineFormInputGroupUsername2"
                          placeholder="Enter Remarks"
                          value={paymentDetails?.paymentRemarks}
                          //  disabled={(isPendingAtFinance ) ?true:false}
                          onChange={(e) =>
                            onChangeHandler("paymentRemarks", e.target.value)
                          }
                        />
                      </div>
                      <div class=" col-lg-3 col-md-5 mt-4">
                        <label className="col-form-label">
                          UTR No
                          <MandatoryStar />
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          style={{ padding: "7px" }}
                          id="inlineFormInputGroupUsername2"
                          placeholder="UTR No"
                          value={paymentDetails?.utr}
                          required
                          //  disabled={(isPendingAtFinance ) ?true:false}
                          // disabled={(!isPendingAtFinance || paymentDetails.advPaymentStatus==="Payment Approved")?true:false}
                          onChange={(e) =>
                            onChangeHandler("utr", e.target.value.trimStart())
                          }
                        />
                      </div>
                      <div className="col-lg-3 col-md-5 mt-4">
                        <label className="col-form-label">
                          Payment Date <MandatoryStar />
                        </label>
                        <input
                          type="date"
                          class="white-form-select"
                          style={{ padding: "7px" }}
                          placeholder="Payment Date"
                          data-date-format="DD MMMM YYYY"
                          value={paymentDetails?.paymentDate}
                          required
                          //  disabled={(isPendingAtFinance )?true:false}
                          max={new Date().toISOString().split("T")[0]}
                          onChange={(e) =>
                            onChangeHandler("paymentDate", e.target.value)
                          }
                        />
                      </div>
                      <div class=" col-lg-3 col-md-5 mt-4">
                        <label className="col-form-label">
                          TDS %<MandatoryStar />
                        </label>
                        <input
                          type="number"
                          step="0.01"
                          presicion={2}
                          onKeyDown={(e) => {
                            if (
                              e.key === " " ||
                              e.key === "-" ||
                              e.key === "+"
                            ) {
                              e.preventDefault(); // Prevent entering a space, minus sign, or plus sign
                            }
                          }}
                          class="form-control"
                          style={{ padding: "7px" }}
                          id="inlineFormInputGroupUsername2"
                          placeholder="TDS %"
                          value={paymentDetails?.tdsPercentage}
                          required
                          disabled={
                            !isPendingAtFinance ||
                            paymentDetails.advPaymentStatus ===
                              "Payment Approved"
                              ? true
                              : false
                          }
                          onChange={(e) =>
                            onChangeHandler("tdsPercentage", e.target.value)
                          }
                        />
                      </div>
                      <div class=" col-lg-3 col-md-5 mt-4">
                        <label className="col-form-label">
                          TDS Amount
                          <MandatoryStar />
                        </label>
                        <input
                          type="number"
                          step="0.01"
                          presicion={2}
                          onKeyDown={(e) => {
                            if (
                              e.key === " " ||
                              e.key === "-" ||
                              e.key === "+"
                            ) {
                              e.preventDefault(); // Prevent entering a space, minus sign, or plus sign
                            }
                          }}
                          class="form-control"
                          style={{ padding: "7px" }}
                          id="inlineFormInputGroupUsername2"
                          placeholder="TDS Amount"
                          value={paymentDetails?.tdsAmount}
                          required
                          disabled={
                            !isPendingAtFinance ||
                            paymentDetails.advPaymentStatus ===
                              "Payment Approved"
                              ? true
                              : false
                          }
                          onChange={(e) =>
                            onChangeHandler("tdsAmount", e.target.value)
                          }
                        />
                      </div>
                      <div className="col-lg-3 col-md-5 mt-4">
                        <label className="col-form-label">
                          Net Amount <MandatoryStar />
                        </label>
                        <input
                          type="number"
                          step="0.01"
                          presicion={2}
                          onKeyDown={(e) => {
                            if (
                              e.key === " " ||
                              e.key === "-" ||
                              e.key === "+"
                            ) {
                              e.preventDefault(); // Prevent entering a space, minus sign, or plus sign
                            }
                          }}
                          class="form-control"
                          style={{ padding: "7px" }}
                          placeholder="Net Amount"
                          value={paymentDetails?.netAmount}
                          required
                          disabled={
                            !isPendingAtFinance ||
                            paymentDetails.advPaymentStatus ===
                              "Payment Approved"
                              ? true
                              : false
                          }
                          onChange={(e) =>
                            onChangeHandler("netAmount", e.target.value)
                          }
                        />
                      </div>
                    </div>
                  )}

                <div class="row">
                  <div class=" col-lg-12 col-md-5 mt-4">
                    <label className="col-form-label">
                      Cancel / Reject Remarks
                     <MandatoryStar />
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      style={{ padding: "7px" }}
                      id="inlineFormInputGroupUsername2"
                      placeholder="Remarks"
                      value={paymentDetails?.rejectRemarks}
                      required={isRejectRemarks === true ? true : false}
                      onChange={(e) =>
                        onChangeHandler(
                          "rejectRemarks",
                          e.target.value.trimStart()
                        )
                      }
                    />
                  </div>
                </div>
                <div class="row">
                  <div class=" col-lg-12 col-md-5 mt-4">
                    {paymentDetails?.advPaymentStatus !== "Payment Approved" &&<button
                      className="reject-btn-indivitual input-text float-end"
                      type="button"
                      style={{
                        cursor: "pointer",
                        marginTop: "20px",
                        justifyContent: "end",
                        height: "43px",
                        fontWeight: "bold"
                      }}
                    

                      onClick={handleButtonClick}
                    >
                      {paymentDetails?.advPaymentStatus === "Pending At Manager"
                        ? "Cancel"
                        : "Reject"}
                    </button>}
                    <button
                      className="input-group-text search float-end"
                      type="submit"
                      style={{
                        cursor: "pointer",
                        marginTop: "20px",
                        justifyContent: "end",
                        height: "43px",
                      }}
                      disabled={
                        isDisable ||
                        (userRoleCode === "SUPER_ADMIN" &&
                          paymentDetails?.advPaymentStatus !==
                            "Pending At Finance")
                      }
                    >
                      Submit
                    </button>

                    {showPopup && (
                      <div style={popupStyle}>
                        <p style={{ fontWeight: "bold",fontSize: "22px"  }}>
                        {paymentDetails?.advPaymentStatus==="Pending At Manager"?"Do you want to cancel the request?":"Do you want to reject the request?"}  
                        </p>
                        <button
                          className="input-group-text search float-end"
                          type="button"
                          style={{
                            cursor: "pointer",
                            marginTop: "60px",
                            justifyContent: "end",
                            height: "43px",
                          }}
                          onClick={() => handleRejectChanges("Yes")}
                        >
                          Yes &nbsp;
                        </button>
                        <button
                          className="input-group-text search float-end"
                          type="button"
                          style={{
                            cursor: "pointer",
                            marginTop: "60px",
                            justifyContent: "end",
                            height: "43px",
                          }}
                          onClick={() => handleRejectChanges("No")}
                        >
                          No &nbsp;
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

        {(paymentDetails?.advanceFor === "PACKAGE" ||
          paymentDetails?.advanceFor === "TEST") &&
          paymentDetails?.paymentFor === "AdvaAmt" &&
          (payoutReducer?.getInsurerPackageDetail?.lstPackage?.length > 0 ||
            payoutReducer?.getInsurerPackageDetail?.lstTest?.length > 0) && (
            <div
              className="staff-table creation-table"
              style={{ marginTop: "-50px" }}
            >
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Select Checkbox</th>
                      <th className="w60">Advance For</th>
                      <th>Advance Insurer Rate</th>
                    </tr>
                  </thead>
                  <tbody>
                    {packageArr?.map((ele, index) => {
                      return (
                        <>
                          <tr>
                            <td>
                              <input
                                className="form-check-input"
                                type="checkbox"
                                style={{ margin: "0 50%" }}
                                checked={checkedPt?.some(
                                  (item) => item === ele
                                )}
                                onChange={(e) => {
                                  if (testOrPackage === "PACKAGE") {
                                    e.target.checked === true
                                      ? setCheckedPt([...checkedPt, ele])
                                      : setCheckedPt(
                                          checkedPt?.filter(
                                            (item) =>
                                              item?.packageId !== ele?.packageId
                                          )
                                        );
                                  } else if (testOrPackage === "TEST") {
                                    e.target.checked === true
                                      ? setCheckedPt([...checkedPt, ele])
                                      : setCheckedPt(
                                          checkedPt?.filter(
                                            (item) =>
                                              item?.testId !== ele?.testId
                                          )
                                        );
                                  } else if (testOrPackage === "ADDTEST") {
                                    if (e.target.checked === true) {
                                      const arr1 = list?.map((item) => {
                                        if (
                                          ele?.packageId === item?.packageId &&
                                          item?.type === null
                                        ) {
                                          return {
                                            ...item,
                                            amount: 0,
                                          };
                                        } else {
                                          return item;
                                        }
                                      });
                                      const arr2 = checkedPt?.filter(
                                        (value) =>
                                          value?.packageId !== ele?.packageId
                                      );
                                      setList(arr1);
                                      setCheckedPt([...arr2, ele]);
                                      // }
                                    } else {
                                      setCheckedPt(
                                        checkedPt?.filter(
                                          (item) =>
                                            item?.packageId !== ele?.packageId
                                        )
                                      );
                                      const arr = packageArr?.map((value) => {
                                        if (
                                          value?.packageId === ele?.packageId
                                        ) {
                                          return {
                                            ...value,
                                            amount: 0,
                                          };
                                        } else {
                                          return value;
                                        }
                                      });
                                      setPackageArr(arr);
                                    }
                                  }
                                }}
                              />
                            </td>
                            <td className="text-center">
                              {paymentDetails?.advanceFor === "PACKAGE" ||
                              testOrPackage === "ADDTEST" ? (
                                <>
                                  <span style={{ fontWeight: "900" }}>
                                    {ele?.type} -
                                  </span>{" "}
                                  {ele?.packageName}
                                </>
                              ) : (
                                ele?.testName
                              )}
                            </td>
                            <td>
                              <input
                                type="number"
                                className={"__inputs font-medium text-black"}
                                style={{ width: "100%" }}
                                placeholder="Enter here..."
                                disabled={
                                  !checkedPt?.some((item) => item === ele)
                                }
                                value={ele?.amount}
                                onKeyDown={(e) => {
                                  if (
                                    e.key === " " ||
                                    e.key === "-" ||
                                    e.key === "+"
                                  ) {
                                    e.preventDefault(); // Prevent entering a space, minus sign, or plus sign
                                  }
                                }}
                                onChange={(e) =>
                                  packagePriceHandler(
                                    index,
                                    "amount",
                                    e.target.value
                                  )
                                }
                                required
                              />
                            </td>
                          </tr>
                          {list?.map((item, index) => {
                            if (ele?.packageId === item?.packageId) {
                              return (
                                <tr key={index}>
                                  <td>
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      style={{ margin: "0 50%" }}
                                      checked={checkedPt?.some(
                                        (value) => value === item
                                      )}
                                      onClick={(e) => {
                                        if (testOrPackage === "TEST") {
                                          e.target.checked === true
                                            ? setCheckedPt([...checkedPt, item])
                                            : setCheckedPt(
                                                checkedPt?.filter(
                                                  (value) =>
                                                    value?.testId !==
                                                    item?.testId
                                                )
                                              );
                                        } else if (
                                          testOrPackage === "ADDTEST"
                                        ) {
                                          if (e.target.checked === true) {
                                            let flag = true;
                                            let arr = checkedPt?.filter(
                                              (data) => {
                                                if (
                                                  data.type === "PACKAGE" &&
                                                  item?.packageId ===
                                                    data?.packageId
                                                ) {
                                                  flag = false;
                                                  return getSnackbarSuccess(
                                                    "warning",
                                                    "Please diselect Package to update test price ",
                                                    dispatch
                                                  );
                                                } else {
                                                  return data;
                                                }
                                              }
                                            );
                                            if (flag === true) {
                                              setCheckedPt([...arr, item]);
                                            }
                                          } else {
                                            setCheckedPt(
                                              checkedPt?.filter(
                                                (value) =>
                                                  value?.testId !== item?.testId
                                              )
                                            );
                                            let arr = list.map((value) => {
                                              if (
                                                value?.testId === item?.testId
                                              ) {
                                                return {
                                                  ...value,
                                                  amount: 0,
                                                };
                                              } else {
                                                return value;
                                              }
                                            });
                                            setList(arr);
                                          }
                                        }
                                      }}
                                    />
                                  </td>
                                  <td className="text-center">
                                    {item?.testName}
                                  </td>
                                  <td>
                                    <input
                                      type="number"
                                      className={
                                        "__inputs font-medium text-black"
                                      }
                                      style={{ width: "100%" }}
                                      placeholder="Enter here..."
                                      value={item?.amount}
                                      onKeyDown={(e) => {
                                        if (
                                          e.key === " " ||
                                          e.key === "-" ||
                                          e.key === "+"
                                        ) {
                                          e.preventDefault(); // Prevent entering a space, minus sign, or plus sign
                                        }
                                      }}
                                      onChange={(e) =>
                                        insurerPriceHandler(
                                          index,
                                          "amount",
                                          e.target.value
                                        )
                                      }
                                      disabled={
                                        !checkedPt?.some(
                                          (value) => value === item
                                        )
                                      }
                                      // required={
                                      //   ele?.amount !== null &&
                                      //   ele?.amount !== ""
                                      //     ? false
                                      //     : true
                                      // }
                                    />
                                  </td>
                                </tr>
                              );
                            }
                          })}
                        </>
                      );
                    })}
                    {addTest?.map((ele, pos) => {
                      return (
                        <tr key={pos}>
                          <td>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              style={{ margin: "0 50%" }}
                              checked={checkedPt?.some((item) => item === ele)}
                              onClick={(e) => {
                                e.target.checked === true
                                  ? setCheckedPt([...checkedPt, ele])
                                  : setCheckedPt(
                                      checkedPt?.filter(
                                        (item) => item?.testId !== ele?.testId
                                      )
                                    );
                              }}
                            />
                          </td>
                          <td className="text-center">
                            <span style={{ fontWeight: "900" }}>
                              Additional Test -{" "}
                            </span>
                            {ele?.testName}
                          </td>
                          <td>
                            <input
                              type="number"
                              className={"__inputs font-medium text-black"}
                              style={{ width: "100%" }}
                              placeholder="Enter here..."
                              value={ele?.amount}
                              onKeyDown={(e) => {
                                if (
                                  e.key === " " ||
                                  e.key === "-" ||
                                  e.key === "+"
                                ) {
                                  e.preventDefault(); // Prevent entering a space, minus sign, or plus sign
                                }
                              }}
                              onChange={(e) =>
                                addTestPriceHandler(
                                  pos,
                                  "amount",
                                  e.target.value
                                )
                              }
                              disabled={
                                !checkedPt?.some((value) => value === ele)
                              }
                            />
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          )}
      </div>
    </>
  );
};

export default AdvancePaymentPayout;
